import sliceCreator from '../../index.jsx';
import {CREATE_AREA} from '../../../constants/index.jsx';
const _createAreaAction = sliceCreator('CREATE_AREA', CREATE_AREA, 'post');

const { asyncAction: createAreaAction, reducer, clearData: clearCreateAreaAction } = _createAreaAction;

export default reducer;

export {
    createAreaAction,
    clearCreateAreaAction
}